export default {
  EET_RESET: 'reset',
  EET_CHANGE_GROUND_TEXTURE: 'change_bg_texture',
  EET_BACKGROUND_CHANGE_COMING: 'background_change_coming',
  EET_COMING_GROUND: 'coming_ground',
}
